import classNames from "classnames";
import { BuildNode, NodeStates, VismaButtonListNode } from "../../build/types";
import { BuilderVismaButtonListProps } from "../BuilderInterface";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import { useInteractionStates } from "../../hooks/useInteractionStates";

interface ButtonListButtonProps {
    node: BuildNode;
    name: string;
    buttonOnClick?: (value: string) => void;
    builder?: boolean;
    nodeState?: NodeStates;
    disabled?: boolean;
}

export const ButtonListButton = ({ node, name, buttonOnClick, builder, nodeState, disabled }: ButtonListButtonProps) => {
    const dNode = node as VismaButtonListNode;
    const { stateManager, buttonStyle } = dNode;
    const { setElement, states } = useInteractionStates<HTMLButtonElement>();

    if (builder) {
        const style = getCompoundStyle({
            otherStyle: buttonStyle,
            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "buttonStyle")
        });

        return <button style={style}>{name}</button>;
    } else {
        const style = getStylesFromInteractiveStates({
            states,
            defaultStyle: buttonStyle,
            stateManager,
            paths: ["buttonStyle"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        return (
            <button ref={setElement} style={style} onClick={() => buttonOnClick && buttonOnClick(name)} disabled={disabled}>
                {name}
            </button>
        );
    }
};

const BuilderVismaButtonList = ({ node, builderProps, children }: BuilderVismaButtonListProps) => {
    const { id, attr, stateManager } = node as VismaButtonListNode;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();
    const BuilderVismaButtonListClass = classNames("builder-visma-button-list", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { isContainer, nodeState, selectCallback, outlineCallback } = builderProps;

        return (
            <div
                {...attr}
                className={BuilderVismaButtonListClass}
                style={getCompoundStyle({
                    node,
                    isContainer: isContainer,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                draggable="false"
            >
                <ButtonListButton node={node} builder nodeState={nodeState} name="Option 1" />
                <ButtonListButton node={node} builder nodeState={nodeState} name="Option 2" />
                <ButtonListButton node={node} builder nodeState={nodeState} name="Option 3" />
            </div>
        );
    } else {
        const { style, ...rest } = attr || {};

        const buttonListStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"]
        });

        return (
            <div ref={setElement} style={buttonListStyle} id={id} {...rest} className={BuilderVismaButtonListClass}>
                {children}
            </div>
        );
    }
};

export default BuilderVismaButtonList;
